import { render } from "./index.vue?vue&type=template&id=8cf2a74e&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&name=navbar"
export * from "./index.vue?vue&type=script&lang=ts&name=navbar"

import "./index.vue?vue&type=style&index=0&id=8cf2a74e&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/K8S-上海阿里云Prod环境-UOTS-Front/frontend/front-uots-simulator/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf2a74e"]])

export default __exports__